<template>
  <div class="verify-layout">
    <!-- 顶部区域开始 -->
    <div class="navigation"
         :class="{ navigation_private: IS_PRIVATE, 'bg-blue': VUE_APP_LOGO == 'logo' }">
      <div class="nav_left no_private" v-if="!IS_PRIVATE">
         <img v-if="logoPng" :src="logoPng" />
         <img v-else src="static/logo.png"/>
      </div>
      <!-- 独立部署图标 -->
       <div class="nav_left is_private" v-else>
        <img :src="`static/logo.png`" />
      </div>
      <!-- <div v-if="$route.name==='newLogin' && (!IS_PRIVATE)" class="nav_right">欢迎使用飞译人机合译平台！</div> -->
      <el-button v-if="!($route.name==='newLogin')" class="nav_right" @click="login_in">登录
      </el-button>
    </div>
    <!-- 顶部区域结束 -->
    <!--  主视图区域开始 -->
    <div class="content">
      <router-view />
    </div>
    <!-- 主视图域结束 -->
    <!-- 底部区域开始 -->
    <!-- <div class="footer" v-if="['personal', 'mdeical', 'campus', 'nation'].includes(VUE_PLATFORM_TYPE)">Copyright @ 2018-2021 anylangtech. All Rights Reserved. 中科凡语 版权所有</div> -->
    <!-- 底部区域结束 -->
  </div>
</template>

<script>
import { checkImgExists } from "@/utils/index";

export default {
  name: "VerifyLayout",
  components: {},
  data() {
    return {
      IS_PRIVATE: IS_PRIVATE,
      VUE_PLATFORM_TYPE: VUE_PLATFORM_TYPE,
      VUE_APP_LOGO: VUE_APP_LOGO,
      IS_ONLINE_PRIVATE: IS_ONLINE_PRIVATE,
      logoPng: '',           // 登录页左上角logo
    };
  },
  mounted() {
    this.logoChange();
  },
  methods: {
    logoChange() {
      switch (this.VUE_PLATFORM_TYPE) {
        case 'demo':
          if (localStorage.myLoginLogoPic && localStorage.myLoginLogoPic !== 'null') {
            checkImgExists(localStorage.myLoginLogoPic).then(() => {
              this.logoPng = localStorage.myLoginLogoPic;
            }).catch(() => {
              this.logoPng = '';
            })
          } else {
            this.logoPng = '';
          }
          break;
        default:
          if (this.IS_ONLINE_PRIVATE) {
            this.logoPng = require(`./assets/images/${this.VUE_APP_LOGO}.png`);
          } else {
            this.logoPng = require('./assets/images/logo.png');
          }
          break;
      }
    },
    goRegister() {
      this.$router.push("/login/registration");
    },
    login_in() {
      if (this.$route.query.key !== undefined) {
        this.$router.push({
          path: "/login/newLogin",
          query: {
            key: this.$route.query.key,
          },
        });
      } else {
        this.$router.push("/login/newLogin");
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>